<template>
	<nav>
		<div>
			<ul>
	            <li>
	                <router-link to="/">
	                    <span>首页</span>
	                </router-link>
	            </li>
	            <li>
	                <router-link to="/aboutus">
	                    <span>关于我们</span>
	                </router-link>
	            </li>
	            <!--<li>
	                <router-link to="/join">
	                    <span>加入我们</span>
	                </router-link>
	            </li>
	            <li>
	                <router-link to="/product">
	                    <span>产品介绍</span>
	                </router-link>
	            </li>-->
	            <li>
	                <router-link to="/jz">
	                    <span>家长监护</span>
	                </router-link>
	            </li>
	            <li>
	                <router-link to="/yh">
	                    <span>用户协议</span>
	                </router-link>
	            </li>
	            <li>
	                <router-link to="/fc">
	                    <span>防沉迷</span>
	                </router-link>
	            </li>
	            <li>
	                <router-link to="/contact">
	                    <span>联系我们</span>
	                </router-link>
	            </li>
	       </ul>
	        <c-loginbar></c-loginbar>
        </div>
   </nav>
</template>

<script>
import cLoginbar from '../components/loginbar';
export default {
  data () {
    return {}
  },
  components: {cLoginbar}
}
</script>

<style scoped>
nav{border-bottom:1px solid #CCC;}
nav>div{margin:0 auto;max-width:960px;padding:0;position:relative;}
nav ul{list-style:none;margin:0 auto;max-width:960px;padding:25px 0 15px 0;text-align:left;position:relative;z-index:2;letter-spacing:0;font-size:0;}
nav ul li{display:inline-block;text-align:center;height:40px;width:10%;outline:none;border:0;padding:0;font-size:16px;}
nav ul li a{font-size:16px;line-height:2.5;text-align:center;color:#000;outline:none;}
nav ul li span{font-weight:bold;outline:none;}
nav ul li a:hover{opacity:.7;text-decoration: none;}
</style>


// WEBPACK FOOTER //
// src/components/nav.vue